<script setup>
import { computed } from "vue";

// rows: [{ name, sub, value, color, uuid? }]
const props = defineProps({
  rows: { type: Array, required: true },
  clickable: { type: Boolean, default: false },
});

const emit = defineEmits(["row-click"]);

const max = computed(() => Math.max(...props.rows.map((r) => r.value)) || 1);
</script>

<template>
  <div class="an-rank">
    <div
      v-for="(r, i) in rows"
      :key="i"
      class="an-rank__row"
      :class="{ 'an-rank__row--link': clickable }"
      @click="clickable && emit('row-click', r, i)"
    >
      <div class="an-rank__name">{{ r.name }}<b v-if="r.sub">{{ r.sub }}</b></div>
      <div class="an-rank__val">{{ r.value }}</div>
      <div class="an-rank__track">
        <div
          class="an-rank__bar"
          :style="{ background: r.color, width: ((r.value / max) * 100).toFixed(1) + '%', animationDelay: i * 0.06 + 's' }"
        ></div>
      </div>
      <span v-if="clickable" class="an-rank__arrow">›</span>
    </div>
  </div>
</template>
